import eventService from './eventService'
import partnerService from './partnerService'

const partner = { eventService, partnerService }

export default partner
